// DashboardTabs.styles.js

const DashboardTabsStyles = {
    container: {
      padding: { xs: '1rem', sm: '1.5rem', md: '2rem' },
      backgroundColor: '#f9f9f9',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
    },
    header: {
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      justifyContent: { xs: 'flex-start', sm: 'space-between' },
      alignItems: { xs: 'flex-start', sm: 'center' },
      gap: { xs: 1.5, sm: 0 },
      marginBottom: { xs: '1rem', sm: '1.5rem' },
      color: '#000000ff',
      width: '100%',
      '& .MuiTypography-h4': {
        fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
        fontWeight: 700,
        mb: { xs: 1, sm: 0 },
      },
    },
    tabs: {
      borderBottom: '2px solid #81c241',
      marginBottom: '1.5rem',
      overflowX: { xs: 'auto', sm: 'visible' },
      '& .MuiTab-root': {
        minWidth: { xs: 80, sm: 120 },
        fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
        padding: { xs: '0.5rem 0.75rem', sm: '0.75rem 1rem' },
        textTransform: 'none',
        fontWeight: 600,
      },
      '& .MuiTabs-indicator': {
        backgroundColor: '#81c241',
      },
    },
    bottomNav: {
      '& .MuiBottomNavigationAction-root': {
        minWidth: { xs: 60, sm: 80 },
        padding: { xs: '6px 4px', sm: '8px 12px' },
        '& .MuiBottomNavigationAction-label': {
          fontSize: { xs: '0.65rem', sm: '0.75rem' },
          marginTop: '4px',
        },
      },
    },
  };
  
  export default DashboardTabsStyles;
  